import React, { useRef, useState, useContext } from 'react';
// @mui
import { Stack, Typography, Button, Tab, Tabs, Box, IconButton } from '@mui/material';
import { Menu, MenuItem, MenuButton, SubMenu } from '@szhsin/react-menu';
import { IoCheckmarkDone } from 'react-icons/io5';
import palette from 'src/theme/palette';
import { MyContext } from 'src/context';
import { notifications } from 'src/utils/data';
import useResponsive from 'src/hooks/useResponsive';

import moment from 'moment';

// ----------------------------------------------------------------------
interface NotificationsProps {}

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

export default function Notifications({}: NotificationsProps) {
  const { setUser } = useContext(MyContext);
  const [value, setValue] = useState(0);
  const isDesktop = useResponsive('up', 'lg');

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <>
      <Typography variant="h5" sx={{ py: 2, textAlign: 'center' }}>
        Notifications
      </Typography>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', px: 2 }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab
            label={
              <Stack direction="row">
                <Typography variant="subtitle1">All</Typography>
                <div
                  style={{
                    width: 20,
                    height: 20,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderRadius: 30,
                    backgroundColor: palette.primary.lighter,
                    fontSize: 10,
                    marginLeft: 10,
                  }}
                >
                  2
                </div>
              </Stack>
            }
            {...a11yProps(0)}
          />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        {notifications.map((notification, i) => {
          return (
            <MenuItem
              key={i}
              style={{
                paddingTop: isDesktop ? 20 : 10,
                paddingBottom: isDesktop ? 20 : 5,
                backgroundColor: notification.read ? '' : palette.grey[300],
              }}
            >
              <img src={notification.image} style={{ width: 48, height: 48, borderRadius: 48, objectFit: 'cover' }} />
              <div style={{ marginLeft: 10 }}>
                <Typography variant="subtitle2" color={palette.common.black}>
                  {notification.description}
                </Typography>
                <Typography variant="caption" sx={{ color: palette.grey[600] }}>
                  {moment(notification.time).fromNow()}
                </Typography>
              </div>
            </MenuItem>
          );
        })}
      </CustomTabPanel>

      <Stack direction="row" justifyContent="space-between" sx={{ px: 1, py: isDesktop ? 2 : 0, mt: 2 }}>
        <Button>
          <IoCheckmarkDone size={24} />
          <Typography variant="subtitle2"> Mark all as read</Typography>
        </Button>
        <Button>
          <Typography variant="subtitle2">See All Notifications</Typography>
        </Button>
      </Stack>
    </>
  );
}
